// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table,
.table td,
.table th {
    cursor: default;
}

.selectLCC option:disabled {
    font-weight: bold;
    color: black;
}

.generalTableSLCA .min-w-100px {
    min-width: 80px !important;
}

.generalTableSLCA .max-w-100px {
    max-width: 80px !important;
}

.generalTableSLCA .critical {
    font-size: 12px;
    margin-bottom: 0px;
    font-weight: bold;
}

.generalTableSLCA .performance-header {
    font-size: 12px;
}

.title2 {
    text-align: center;
    margin-bottom: 20px;
    text-transform: uppercase;
    font-weight: bold;
    text-decoration: underline;
    font-size: 12px;
}

.btn-group-xs>.btn,
.btn-xs {
    padding: 1px 5px !important;
    font-size: 12px !important;
    line-height: 1.5 !important;
    border-radius: 3px !important;
}

.weight-table td {
    vertical-align: middle;
}

.chart {
    width: 250px;
    height: 400px;
}

.chart .values {
    float: left;
    height: 400px;
    width: 100px;
    margin-top: -20px;
}

.chart .values li {
    list-style: none;
    font-size: 12px;
    height: calc(400px / 10);
    line-height: calc(400px / 10);
}

.chart .graph {
    width: 150px;
    height: 400px;
    margin-left: 100px;
    background-image: linear-gradient(green, yellow, red);
    position: relative;
}

.chart .graph .circle{
    width: 50px;
    height: 50px;
    background-color: #ddd;
    border-radius: 50%;
    left: 50px;
    position: absolute;
}

.select-form {
    display: block;
    width: 100%;
    padding: 0;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--bs-body-color);
    appearance: none;
    background-color: var(--bs-body-bg);
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    background-size: 16px 12px;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

.select-form > div{
    border: none !important;
}

.select-form svg{
    color: #676b70;
}`, "",{"version":3,"sources":["webpack://./src/pages/LCSA/lcsa.css"],"names":[],"mappings":"AAAA;;;IAGI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB;IACjB,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;;IAEI,2BAA2B;IAC3B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,qDAAqD;IACrD,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,yCAAyC;IACzC,0BAA0B;IAC1B,2DAA2D;IAC3D,sCAAsC;IACtC,qEAAqE;AACzE;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB","sourcesContent":[".table,\n.table td,\n.table th {\n    cursor: default;\n}\n\n.selectLCC option:disabled {\n    font-weight: bold;\n    color: black;\n}\n\n.generalTableSLCA .min-w-100px {\n    min-width: 80px !important;\n}\n\n.generalTableSLCA .max-w-100px {\n    max-width: 80px !important;\n}\n\n.generalTableSLCA .critical {\n    font-size: 12px;\n    margin-bottom: 0px;\n    font-weight: bold;\n}\n\n.generalTableSLCA .performance-header {\n    font-size: 12px;\n}\n\n.title2 {\n    text-align: center;\n    margin-bottom: 20px;\n    text-transform: uppercase;\n    font-weight: bold;\n    text-decoration: underline;\n    font-size: 12px;\n}\n\n.btn-group-xs>.btn,\n.btn-xs {\n    padding: 1px 5px !important;\n    font-size: 12px !important;\n    line-height: 1.5 !important;\n    border-radius: 3px !important;\n}\n\n.weight-table td {\n    vertical-align: middle;\n}\n\n.chart {\n    width: 250px;\n    height: 400px;\n}\n\n.chart .values {\n    float: left;\n    height: 400px;\n    width: 100px;\n    margin-top: -20px;\n}\n\n.chart .values li {\n    list-style: none;\n    font-size: 12px;\n    height: calc(400px / 10);\n    line-height: calc(400px / 10);\n}\n\n.chart .graph {\n    width: 150px;\n    height: 400px;\n    margin-left: 100px;\n    background-image: linear-gradient(green, yellow, red);\n    position: relative;\n}\n\n.chart .graph .circle{\n    width: 50px;\n    height: 50px;\n    background-color: #ddd;\n    border-radius: 50%;\n    left: 50px;\n    position: absolute;\n}\n\n.select-form {\n    display: block;\n    width: 100%;\n    padding: 0;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: var(--bs-body-color);\n    appearance: none;\n    background-color: var(--bs-body-bg);\n    background-repeat: no-repeat;\n    background-position: right 0.75rem center;\n    background-size: 16px 12px;\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-radius: var(--bs-border-radius);\n    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n}\n\n.select-form > div{\n    border: none !important;\n}\n\n.select-form svg{\n    color: #676b70;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
